import { UserDTO } from '@behavior/init/dto/UserDTO';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Card, Icon } from 'semantic-ui-react';
import styles from '../styles/Activity.module.scss';
import UserDateInput from '../UserDateInput';
import { AssessorDTO } from '@behavior/activity/dto/AssessorDTO';
import { ActivityInitialDataResponse } from '@components/Activity/types/ActivityInitialDataResponse';

type Props = {
  initialData?: ActivityInitialDataResponse;
  assessorContent: AssessorDTO;
  setAssessorContent?: (assessorContent: AssessorDTO) => void;
  onRemove?: () => void;
  disabled?: boolean;
  index: number;
};

const AssessorCard = ({
  initialData,
  assessorContent,
  setAssessorContent,
  onRemove,
  disabled,
  index,
}: Props) => {
  const { t } = useTranslation();
  const [userDateValidation, setUserDateValidation] = useState(0);
  const currentUser = initialData?.currentUser;
  const [userValueWithoutPersonalData, setUserValueWithoutPersonalData] = useState(
    assessorContent.person
  );
  const ASSESSORS_BASE = `assessors[${index}]`;
  const setDefaultUser = (clear: boolean) => {
    if (setAssessorContent) {
      setAssessorContent({
        ...assessorContent,
        person: clear ? undefined : currentUser,
      });
    }
  };

  const updateUserDateFieldsValidation = (selectedOption?: UserDTO) => {
    setUserDateValidation(userDateValidation + 1);
    if (setAssessorContent) {
      setAssessorContent({
        ...assessorContent,
        person: selectedOption,
      });
    }
  };

  const updateDataField = (selectedOption: any) => {
    if (setAssessorContent) {
      setAssessorContent({
        ...assessorContent,
        signatureDte: selectedOption,
      });
    }
  };

  const setFieldVal = (val: string, date: any) => {
    if (setAssessorContent) {
      setAssessorContent({
        ...assessorContent,
        signatureDte: date,
      });
    }
  };

  return (
    <Card className={styles.cardText}>
      <div className={styles.basicDiv}>
        <div className={styles.flexContainerActivity}>
          <div className={styles.chemicalTextHeader}>
            {t('traceability.form.details.page.container.assessor.title')}
          </div>

          {!disabled && (
            <div className={styles.closeButton}>
              <Icon name="close" size="small" color="blue" onClick={onRemove} />
            </div>
          )}
        </div>
        <UserDateInput
          setDefaultUser={setDefaultUser}
          updateUserDateFieldsValidation={updateUserDateFieldsValidation}
          updateDataField={updateDataField}
          setFieldVal={setFieldVal}
          userVal={assessorContent.person}
          userValueWithoutPersonalData={userValueWithoutPersonalData}
          setUserValueWithoutPersonalData={setUserValueWithoutPersonalData}
          dteVal={assessorContent.signatureDte}
          placeholder={t('traceability.form.details.page.container.assessor')}
          nameUser={ASSESSORS_BASE + '.assessor'}
          dteName={ASSESSORS_BASE + '.assessorDte'}
          disabled={disabled}
        />
      </div>
    </Card>
  );
};

export default AssessorCard;
